import SuperAdminModule from 'pages/SuperAdminModule';
import React from 'react';
import { AdminModule } from 'pages/AdminModule';
import { useRole } from 'common/hooks/useRole';
import { useIdleDetector } from 'common/hooks/useIdleDetector';
import { useWarnToastDetector } from 'common/hooks/useWarnToastDetector';
import { useTokenExpDetector } from 'common/hooks/useTokenExpDetector';

export const AdminRouter = () => {
  const { isSuperAdmin } = useRole();

  useWarnToastDetector();
  useIdleDetector();
  useTokenExpDetector();

  return isSuperAdmin ? <SuperAdminModule /> : <AdminModule />;
};
